import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import SortContext from "context/SortContext";
import RenderSubStock from "features/Stock/subcategory/components/SubStocks";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePermissionFlags } from "utils/visionRights";

const SubStock = () => {
  const location = useLocation();
  const { setIsSetFilter, setFilterValues, setBackendFilterValues } = useFilter();
  const { setSortOptions, setSelectedSortValue, setSearch, selectedSortValue, sortOptions, sortValue } = React.useContext(SortContext);
  const { setSearchPlaceHolder } = useGlobalContext();
  const permissions = usePermissions();
  const { stockLocations } = usePermissionFlags();

  React.useEffect(() => {
    setSearch("");
    setSortOptions([
      { id: 1, name: "Alphabetical Quote (A to Z)", sortBy: "alphabetical", order: "asc" },
      { id: 2, name: "Alphabetical Quote (Z to A)", sortBy: "alphabetical", order: "desc" },
      { id: 3, name: "Stocks (High to Low)", sortBy: "quantity", order: "desc" },
      { id: 4, name: "Stocks (Low to High)", sortBy: "quantity", order: "asc" },
    ]);
    setIsSetFilter(true);
    setSearchPlaceHolder("Search by Jewel Code or Design Number");
    return () => {
      setSearchPlaceHolder("Search");
      setIsSetFilter(false);
      setFilterValues((prev) => ({
        ...prev,
        Location: prev?.Location?.length ? prev.Location : [],
      }));
      setSortOptions([]);
      setSelectedSortValue(null);
      setSearch("");
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  React.useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  React.useEffect(() => {
    let filterData = {
      Location: stockLocations.length > 0 ? stockLocations : [],
      "Stock Status": ["All", "On Hand", "On Memo"],
    };

    setBackendFilterValues(filterData);
    setFilterValues((prev) => ({
      ...filterData,
      // Location: prev?.Location?.length ? prev.Location : filterData.Location,
      "Stock Status": prev["Stock Status"] ? prev["Stock Status"] : filterData["Stock Status"],
    }));

    let filterChangeCount = JSON.parse(sessionStorage.getItem("filterChangeCount"));

    if (filterChangeCount == 0) {
      setFilterValues((prev) => ({
        ...filterData,
        Location: prev?.Location?.length ? prev.Location : filterData.Location,
        "Stock Status": prev["Stock Status"] ? prev["Stock Status"] : filterData["Stock Status"],
      }));
    } else {
      const savedFilters = JSON.parse(sessionStorage.getItem("appliedFilterValues") || "{}");
      const newFilters = {
        Location: savedFilters.Location || filterData?.Location || [],
        "Stock Status": savedFilters["Stock Status"] || ["All","On Hand", "On Memo"],
      };
      setFilterValues(newFilters);
    }
  }, [permissions]);

  useEffect(() => {
    setSearch(location?.state?.subStockSearch || "");
  }, [location]);

  return <RenderSubStock />;
};

export default SubStock;
